import { quoteOrTabRemoved } from 'epic/workspace/common/tabs/tabsEpics/quoteOrTabRemoved';
import type { RegulatoryDocument } from 'models/streaming';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, filter, map, mergeMap, take, takeUntil, timeoutWith } from 'rxjs/operators';
import {
  productGovernanceDocumentReceived,
  productGovernanceDocumentTimeout,
} from 'state/quotes/regulations/regulation.actions';
import { isQuoteTypeWithRegulation } from 'state/quotes/utils';
import type { EpicWithThunk } from 'state/state.common';
import { fatEventApiConnector } from 'utils/streaming/api';
import { productGovernanceDocument } from 'utils/streaming/messages';

// TODO catch Error in Epic
export function productGovernanceDocumentEpic(appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { oldHttpClient, getSgmeConfiguration, streaming }) =>
    action$.pipe(
      ofType('QUOTE_ACKED'),
      filter(x => x.workspace === 'dynamic' && isQuoteTypeWithRegulation(x.quoteType)),
      mergeMap(({ tabId, quoteId }) => {
        const quoteOrTabRemoved$ = quoteOrTabRemoved(action$, tabId, quoteId, state$);
        const pgTimeoutMs = getSgmeConfiguration().pgTimeoutMs;
        return productGovernanceDocument(streaming).pipe(
          filter(x => x.quoteId === quoteId),
          mergeMap(lightEvent =>
            fatEventApiConnector(oldHttpClient)
              .getFatEvent<RegulatoryDocument>(lightEvent)
              .pipe(
                catchError(_ => EMPTY),
                map(doc => productGovernanceDocumentReceived('dynamic', tabId, quoteId, doc)),
              ),
          ),
          takeUntil(quoteOrTabRemoved$),
          take(1),
          timeoutWith(pgTimeoutMs, of(productGovernanceDocumentTimeout('dynamic', tabId, quoteId)), appScheduler),
        );
      }),
    );
}
